import components from './components.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import aiOnboarding from './aiOnboarding.json';
import aiSettings from './aiSettings.json';
import businessData from './businessData.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import webhooks from './webhooks.json';
import whatsappTemplates from './whatsappTemplates.json';
import orders from './orders.json';
import mfa from './mfa.json';

function deepMerge(target, ...sources) {
  sources.forEach(source => {
    if (!source) return;
    Object.keys(source).forEach(key => {
      const sourceValue = source[key];
      const targetValue = target[key];
      if (Array.isArray(sourceValue)) {
        target[key] = sourceValue.slice();
      } else if (sourceValue && typeof sourceValue === 'object') {
        const base = targetValue && typeof targetValue === 'object' ? targetValue : {};
        target[key] = deepMerge({ ...base }, sourceValue);
      } else {
        target[key] = sourceValue;
      }
    });
  });
  return target;
}

const vi = deepMerge(
  {},
  components,
  advancedFilters,
  agentBots,
  agentMgmt,
  aiOnboarding,
  aiSettings,
  businessData,
  attributesMgmt,
  auditLogs,
  automation,
  bulkActions,
  campaign,
  cannedMgmt,
  chatlist,
  contact,
  contactFilters,
  conversation,
  csatMgmt,
  emoji,
  generalSettings,
  helpCenter,
  inboxMgmt,
  integrationApps,
  integrations,
  labelsMgmt,
  login,
  macros,
  report,
  resetPassword,
  search,
  setNewPassword,
  settings,
  signup,
  teamsSettings,
  whatsappTemplates,
  orders,
  inbox,
  general,
  datePicker,
  customRole,
  sla,
  webhooks,
  mfa
);

export default vi;
